import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import { FilterInfo } from '#/DefaultViewExtensionInterfaces';
import CrontabViewModel from '@/ViewModels/Controls/CrontabViewModel';
import Crontab from '@/Controls/Crontab';
import Utilities from '@/Utility/Utilities';

export default class CrontabFactory extends ControlFactory {
    private jQueryControl: JQuery;
    private CrontabViewModel = ComponentManager.getViewModel<typeof CrontabViewModel>('CrontabViewModel');
    private Crontab = ComponentManager.getControl<typeof Crontab>('Crontab');

    public viewModel: CrontabViewModel;

    public constructor(private params: any) {
        super(params);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = new this.CrontabViewModel({
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            invalidationText: this.invalidationText,
            value: this.context.genericObject.getObservable(this.detailViewItem.name),
            parentLocator: this.locator,
            locator: this.detailViewItem.name
        });

        this.control = new this.Crontab(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.registerDefaultValidation([this.detailViewItem.name]);
        this.registerCustomValidation([this.detailViewItem.name], this.viewModel.value, this.viewModel.validate.bind(this.viewModel));

        return this.jQueryControl;
    }

    /**
     * @override
     */
    public getValueForFilter() {
        let ret = {};
        ret[this.detailViewItem.name] = this.context.genericObject.getValue(this.detailViewItem.name);
        return ret;
    }

    /**
     * @override
     */
    public getFilterInfo(): FilterInfo {
        return {
            field: this.detailViewItem.name,
            value: this.viewModel?.value() || ''
        }
    }
}

ComponentManager.setFactory('Crontab', CrontabFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');